/* script */

import translateMixin from '../mixins/translate-mixin.js';
import currencyMixin from '../mixins/currency-mixin';

const __vue_script__ = {
  mixins: [translateMixin, currencyMixin],
  data() {
    return {
      longPage: false,
      code: null,
      isSubscription: !!window.plan,
      showCoupon: !!window.offer,
      optionForm: window.option_form,
      multipleOrderBump: [],
      multipleOrderBumpInstallments: {},
      cardData: {
        number: "",
        holder_name: "",
        exp_month: "",
        exp_year: "",
        cvv: "",
        installments: window.product.order_installment === "desc" ? Object.keys(window.product.installments)[Object.keys(window.product.installments).length - 1] : 1
      },
      billetInstallments: window.product.order_installment === "desc" ? window.product.billet_installments : 1,
      type: (window.product.billet_installments && window.product.billet_installments > 1) ? "billet-installments" : (product.payment_methods.includes("credit_card") ? "card" : product.payment_methods[0]),
      loading: false,
      discount: null,
      appliedCoupon: null,
      refreshingPage: false,
      productType: ({
        'ebook': 'Ebook',
        'online_course': 'Curso online',
        'onsite_event': 'Evento presencial',
        'signature': 'Assinatura'
      })[product.type_product],
    }
  },
  methods: {
    applyDiscount(data) {
      this.discount = data.discount;
      this.appliedCoupon = data.coupon;
      window.product.installments = data.installments;
      this.refreshPage();
    },
    refreshPage() {
      this.refreshingPage = true;
      setTimeout(() => {
        this.refreshingPage = false;
      }, 1);
    }
  }
}

/* template */

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = undefined
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/pages/checkout.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__